import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';


import { Column, GridOption, AngularGridInstance, Formatters } from 'angular-slickgrid';
import { CustomInputEditor } from '../custom-inputEditor';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-schedule-ticket',
    templateUrl: './schedule-ticket.component.html',
    styleUrls: ['./schedule-ticket.component.css']
})
export class ScheduleTicketComponent implements OnInit, OnDestroy {
    description: string;
    clientId: number;
    ttypes = [];
    ticketSelected: number;
    ticketTypeId: number;
    categoryLoaded: boolean;
    private baseCategories = [];
    ticketTypes: any;
    cat = [];
    dynamicFields = [];
    priorityType: number;
    columnDefinitions = [];
    ticketType: string;
    ticket_status = [];
    activitySelected: number;
    ticketStatus: string;
    activityType: any;
    activityValue: string;
    activityTypeName: string;
    ticketTitle: string;
    ticketDesc: string;
    activityTypeId: number;
    sourceType: string;
    ticketTypeSeq: number;
    hideAddmore: boolean;
    priorityId = 0;
    priority: string;
    support_group = [];
    groupSelected: number;
    users = [];
    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;

    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    userName: string;
    name: string;
    userGroups = [];
    userGroupSelected: number;
    userGroupId: number;
    groupName: string;
    grpLevel: number;
    private disabledCount: number;
    minDate: any;
    dataLoaded: boolean;
    @ViewChild('openActivityValueDetail') private openActivityValueDetail;
    myModal: any;
    itemValue: any;
    value: any;
    value1: any;
    value2: any;
    value3: any;
    value4: any;
    value5: any;
    value6: any;
    adhocLoad: boolean;
    dailyLoad: boolean;
    weeklyLoad: boolean;
    monthlyLoad: boolean;
    quarterlyLoad: boolean;
    val: string;
    priorityArr = [];
    urgencies = [];
    impacts = [];
    urgency: number;
    impact: number;
    selectedPriority: number;
    scheduleStartDate: any;
    scheduleDuration: any;
    plannedStartDt: any;
    plannedEndDt: any;
    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            item.createdBy = this.messageService.getUserId();
                            this._rest.editAutoTicket(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // console.log('data--Done');
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    // console.log('data--Not---Done');
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteAutoTicket({ id: item.id, user_id: this.messageService.getUserId() }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
                case 'showTicket':
                    // console.log(JSON.stringify(item));
                    // console.log(JSON.stringify(item.activity_value));
                    this.myModal = this.modalService.open(this.openActivityValueDetail, {});
                    this.itemValue = item;
                    // console.log("itemvalue"+JSON.stringify(this.itemValue));
                    // console.log("activity type"+this.itemValue.activity_type);
                    switch (item.activity_type) {
                        case 'Daily':
                            this.dailyLoad = true;
                            this.adhocLoad = false;
                            this.weeklyLoad = false;
                            this.monthlyLoad = false;
                            this.quarterlyLoad = false;
                            this.value2 = [];
                            this.val = 'Time' + ' : ' + this.itemValue.activity_value;
                            this.value2.push(this.val);
                            break;
                        case 'Adhoc':
                            this.adhocLoad = true;
                            this.dailyLoad = false;
                            this.weeklyLoad = false;
                            this.monthlyLoad = false;
                            this.quarterlyLoad = false;
                            this.value2 = [];
                            const str = '' + this.itemValue.activity_value;
                            const arr = str.split(' ');
                            this.val = 'Date' + ': ' + arr[0];
                            this.value2.push(this.val);
                            const val1 = 'Time' + ': ' + arr[1];
                            this.value2.push(val1);
                            break;
                        case 'Quarterly':
                            this.quarterlyLoad = true;
                            this.adhocLoad = false;
                            this.dailyLoad = false;
                            this.weeklyLoad = false;
                            this.monthlyLoad = false;
                            this.value = JSON.parse(item.activity_value);
                            this.value6 = this.value;
                            break;
                        case 'Weekly':
                            this.value = JSON.parse(item.activity_value);
                            this.weeklyLoad = true;
                            this.adhocLoad = false;
                            this.dailyLoad = false;
                            this.monthlyLoad = false;
                            this.quarterlyLoad = false;
                            this.value3 = [];
                            this.value4 = [];
                            for (let i = 0; i < 7; i++) {
                                for (let key in this.value[i]) {
                                    if (key !== 'time') {
                                        const string = '' + key;
                                        const str1 = string[0].toUpperCase() + string.slice(1);
                                        this.value3.push(str1);
                                        this.val = '' + this.value[i].time;
                                        this.value4.push(this.val);
                                    }
                                }
                            }
                            break;
                        case 'Monthly':
                            this.value = JSON.parse(item.activity_value);
                            this.monthlyLoad = true;
                            this.adhocLoad = false;
                            this.dailyLoad = false;
                            this.weeklyLoad = false;
                            this.quarterlyLoad = false;
                            this.value5 = this.value;
                            break;
                    }
                    break;
            }
        });
    }
    ngOnInit() {
        this.adhocLoad = false;
        this.dailyLoad = false;
        this.weeklyLoad = false;
        this.monthlyLoad = false;
        this.quarterlyLoad = false;
        this.dataLoaded = false;
        this.groupSelected = 0;
        this.hideAddmore = true;
        this.ticketDesc = '';
        this.ticketTitle = '';
        this.activityValue = '';
        this.activitySelected = 0;
        this.categoryLoaded = true;
        this.ticketSelected = 0;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.plannedStartDt = '';
        this.plannedEndDt = '';
        this.scheduleStartDate = '';
        this.scheduleDuration = '';
        this.displayData = {
            pageName: 'Schedule Ticket',
            openModalButton: 'Add Schedule Ticket Configuration..',
            breadcrumb: 'Schedule Ticket',
            folderName: 'Schedule Ticket',
            tabName: 'Schedule Ticket'
        };
        this.columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'ticketType', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true
            },
            {
                id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true
            },
            {
                id: 'ticket_title', name: 'Ticket Title', field: 'ticket_title', sortable: true, filterable: true, editor: {
                    model: CustomInputEditor
                }
            },
            {
                id: 'ticket_description', name: 'Ticket Description', field: 'ticket_description', sortable: true, filterable: true,
                editor: { model: CustomInputEditor }
            },
            {
                id: 'activity_type', name: 'Activity Type', field: 'activity_type', sortable: true, filterable: true
            },
            {
                id: 'activity_value', name: 'Activity Value', field: 'activity_value', sortable: true, filterable: true
            }

        ];
        this.messageService.setColumnDefinitions(this.columnDefinitions);
        if (this.messageService.getUserId() === null || this.messageService.getToken() === null) {
            this.messageService.clearSession();
            window.location.href = this.messageService.API_ROOT;
        } else {
            if (this.messageService.clientId) {
                this.clientId = this.messageService.clientId;
                this.userGroups = this.messageService.groupId;
                this.userName = this.messageService.loginName;
                // this.groupName = this.userGroups[0].grpName;
                // this.userGroupId = this.userGroups[0].groupId;
                if (this.userGroups !== undefined) {
                    if (this.messageService.getSupportGroup() === null) {
                        this.userGroupId = this.userGroups[0].groupId;
                        this.groupName = this.userGroups[0].grpName;
                        this.grpLevel = this.userGroups[0].level;
                    } else {
                        const group = this.messageService.getSupportGroup();
                        this.userGroupId = group.groupId;
                        this.groupName = group.grpName;
                        this.grpLevel = group.level;
                    }
                    this.userGroupSelected = this.userGroupId;
                }
                this.onPageLoad();
            } else {
                this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                    this.clientId = auth[0].clientId;
                    this.userGroups = auth[0].groupId;
                    this.userName = auth[0].login_name;
                    // this.groupName = this.userGroups[0].grpName;
                    // this.userGroupId = this.userGroups[0].groupId;
                    if (this.userGroups !== undefined) {
                        if (this.messageService.getSupportGroup() === null) {
                            this.userGroupId = this.userGroups[0].groupId;
                            this.groupName = this.userGroups[0].grpName;
                            this.grpLevel = this.userGroups[0].level;
                        } else {
                            const group = this.messageService.getSupportGroup();
                            this.userGroupId = group.groupId;
                            this.groupName = group.grpName;
                            this.grpLevel = group.level;
                        }
                        this.userGroupSelected = this.userGroupId;
                    }
                    this.onPageLoad();
                    // }
                });
            }
        }
    }

    onPageLoad() {
        const now = new Date();
        const previousDate = new Date(now.setDate(now.getDate()));
        const previousMonth = previousDate.getMonth();
        const previousDay = previousDate.getDate();
        const previousYear = previousDate.getFullYear();
        this.minDate = new Date(previousYear, previousMonth, previousDay);
        this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                if (this.grpLevel === 0) {
                    this.ttypes = this.respObject.details.slice(0, 2);
                    this.ttypes.unshift({ id: 0, name: 'Select Ticket Type' });
                } else {
                    this.ttypes = this.respObject.details;
                    this.ttypes.unshift({ id: 0, name: 'Select Ticket Type' });
                }
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });

        this._rest.getUserDetailsByLoginId(this.clientId, this.userName).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.name = this.userName + '-' + this.messageService.xorEncode(atob(this.respObject.details[0].email),
                    this.messageService.SECRET_TOKEN) +
                    '-' + this.messageService.xorEncode(atob(this.respObject.details[0].mobile), this.messageService.SECRET_TOKEN);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
        this.getTableData();
    }

    onTicketChange(selectedIndex: any) {
        this.dynamicFields = [];
        this.ticketTypeId = this.ttypes[selectedIndex].id;
        this.ticketType = this.ttypes[selectedIndex].name;
        this.ticketTypeSeq = this.ttypes[selectedIndex].seq;
        this.priority = '';
        this.priorityId = 0;
        // if (this.priorityType === 1) {
        if (this.ticketTypeSeq === 5 || this.ticketTypeSeq === 6) {
            this._rest.getPriorityClientWise(this.clientId, this.ticketSelected).subscribe((res5) => {
                this.respObject = res5;
                if (this.respObject.success) {
                    this.respObject.details.unshift({
                        id: 0,
                        priority: 'Select Priority'
                    });
                    this.priorityArr = this.respObject.details;
                    this.selectedPriority = 0;
                }
            });
        }
        this._rest.getCreateTicketData(this.messageService.getUserId(), this.ticketSelected, this.clientId)
            .subscribe((res6) => {
                this.respObject = res6;
                this.categoryLoaded = true;
                if (this.respObject.success) {
                    // this.cat = [];
                    // this.clientId = this.respObject.details[0].clientId;
                    this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                    this.priorityType = this.respObject.details[0].val.type;
                    this.ticketTypes = this.respObject.details[0].attribute;
                    this.cat = [];
                    this.respObject.details[0].val.urgency.unshift({
                        id: 0,
                        name: 'Select Urgency'
                    });
                    this.respObject.details[0].val.impact.unshift({
                        id: 0,
                        name: 'Select Bussiness Impact'
                    });
                    this.urgencies = this.respObject.details[0].val.urgency;
                    this.impacts = this.respObject.details[0].val.impact;
                    this.urgency = 0;
                    this.impact = 0;
                    // this.priority = '';
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        // }
    }




    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.description = '';
            this.ticketTypes = [];
            this.ticketSelected = 0;
            this.activityTypeId = 0;
            this.hideAddmore = true
            this.dynamicFields = [];
            this.modalService.open(content, { size: 'lg' }).result.then((result) => {
            }, (reason) => {

            });
        }
    }


    onCategoryChange(ticket, option) {
        // console.log(JSON.stringify(option), typeof option, JSON.stringify(ticket));
        // if(this.ticketTypes)

        const opt = JSON.parse(option);
        if (opt.type !== 'header') {
            // if (this.attachment.length > 0) {
            //   this.attachment = [];
            // }
            const value = opt.id;
            let matched = false;
            const index = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            // // console.log('index:' + index);
            const index1 = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            const pid = this.ticketTypes[index1].options[0].id;
            // // console.log(this.ticketTypes[index1].options[0]);
            if (index === 2) {
                const pid1 = this.baseCategories[0].options[1].id;
                // const pid2 = this.baseCategories[1].options[1].id;
                const cid1 = this.baseCategories[0].options[0].id;
                // const cid2 = this.baseCategories[1].options[0].id;
                if (this.cat.length === 0) {
                    this.cat.push({ pid: pid1, cid: cid1 });
                }
            }
            if (this.cat.length === 0) {
                this.cat.push({ pid: pid, cid: value });
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({ pid: pid, cid: value });
                } else {
                    for (let i = index; i < this.cat.length; i++) {
                        // // console.log('matched');
                        // // console.log(this.cat[i]);
                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }
            if (index > -1) {
                // console.log('index:' + index);
                for (let i = index + 1; i < this.ticketTypes.length; i++) {
                    const options = this.ticketTypes[i].options;
                    // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.ticketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }
            // if (index === 2 && (this.ticketTypeSeq === 2)) {
            //     this.selectedCatVal = value;
            //     // this.getRSDBData('1');
            // }
            let cats = '';
            const catsArr = [];
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    catsArr.push(this.cat[i]);
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                }
            }
            for (let i = 0; i < catsArr.length; i++) {
                if (catsArr[i].cid !== 0) {
                    if (i === catsArr.length - 1) {
                        cats += catsArr[i].cid;
                    } else {
                        cats += catsArr[i].cid + ',';
                    }
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                }
            }
            this._rest.getTicketFieldsCatWise({
                clientId: this.clientId,
                catId: cats,
                ticketTypeId: this.ticketSelected
            }).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // // console.log(JSON.stringify(this.respObject.details));
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        if (this.respObject.details[i].predifinedValue !== null) {
                            this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                            this.respObject.details[i].value = this.respObject.details[i].values[0];
                        } else {
                            this.respObject.details[i].value = '';
                        }
                    }
                    this.dynamicFields = this.respObject.details;
                    // console.log(JSON.stringify(this.dynamicFields));
                } else {
                }
            }, (err) => {
            });
            // // console.log('index:'+index);
            let data;
            if (index > -1) {
                data = this.ticketTypes[index].options[0];
                this.ticketTypes[index].options = [];
                this.dataLoaded = false;
            }

            this._rest.getAttributesParentWiseWithPriority(this.clientId, value, this.priorityType, this.ticketSelected).subscribe((res) => {
                let respObject;
                respObject = res;
                // // console.log(JSON.stringify(this.respObject));

                if (respObject.success) {
                    this.dataLoaded = true;
                    if (respObject.details.val) {
                        // data = this.ticketTypes[index].options[0];
                        respObject.details.val.unshift(data);
                        this.ticketTypes[index].options = respObject.details.val;
                    }
                    if (respObject.details.priority) {
                        this.priority = respObject.details.priority.name;
                        this.priorityId = respObject.details.priority.id;
                    }
                } else {
                    this.dataLoaded = true;
                    if (index > -1) {
                        this.ticketTypes[index].options = [data];
                    }
                    // this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }

    timeFormat(date) {
        // console.log(date);
        if (date !== null && date !== 0 && date !== undefined) {
            const d = new Date(date);
            const utcdate = d.getUTCDate();
            const month = d.getUTCMonth() + 1;
            const year = d.getUTCFullYear();
            // const hour = d.getUTCHours();anand
            // const min = d.getUTCMinutes(); anand 
            const hour = d.getHours();
            const min = d.getMinutes();
            // console.log('utc min' + min);
            let nHour, nMin;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            return utcdate + '-' + month + '-' + year + ',' + nHour + ':' + nMin;
        } else {
            return '00-00-0000,00:00';
        }
    }

    timeFormat1(date) {
        // console.log(date);
        if (date !== null && date !== 0 && date !== undefined) {
            const d = new Date(date);
            const utcdate = d.getUTCDate();
            const month = d.getUTCMonth() + 1;
            const year = d.getUTCFullYear();
            // const hour = d.getUTCHours();anand
            // const min = d.getUTCMinutes();anand

            const hour = d.getHours();
            const min = d.getMinutes();

            // console.log('utc min' + min);
            let nHour, nMin;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            return year + '-' + month + '-' + utcdate + ',' + nHour + ':' + nMin;
        } else {
            return '0000-00-00,00:00';
        }
    }

    save() {
        let extrafields = '';
        let extraCount = 0;
        let isAddFieldMissing = false;
        let cats = '';
        let createTicketCat = '';
        let categoryName = '';
        let isError = false;
        const assetIds = [];
        let activity = '';
        if (this.activityValue !== '' && this.activityValue !== null) {
            activity = this.timeFormat(this.activityValue);
        } else {
            activity = '';
        }
        // console.log('cat==' + JSON.stringify(this.cat) + '============ ticket type====' + JSON.stringify(this.ticketTypes));
        // if (this.cat.length === this.ticketTypes.length) {
        //     for (let i = 0; i < this.cat.length; i++) {
        //         if (this.cat[i].cid !== 0) {
        //             cats += this.cat[i].cid;
        //             if (i !== this.cat.length - 1) {
        //                 cats += ',';
        //             }
        //             if (categoryName === '') {
        //                 categoryName = this.cat[i].catName;
        //             } else {
        //                 categoryName += ' / ' + this.cat[i].catName;
        //             }
        //             // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
        //         }
        //     }
        //
        //     for (let i = 0; i < this.cat.length; i++) {
        //         if (this.cat[i].cid !== 0) {
        //             createTicketCat += this.cat[i].pid + '#' + this.cat[i].cid;
        //             if (i !== this.cat.length - 1) {
        //                 createTicketCat += ',';
        //             }
        //         } else {
        //             isError = true;
        //             break;
        //         }
        //     }
        // } else {
        //     isError = true;
        // }
        console.log('category====' + this.cat.length + '=================' + this.ticketTypes.length);
        if (this.cat.length === this.ticketTypes.length) {
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    cats += this.cat[i].cid;
                    if (i !== this.cat.length - 1) {
                        cats += ',';
                    }
                    if (categoryName === '') {
                        categoryName = this.cat[i].catName;
                    } else {
                        categoryName += ' / ' + this.cat[i].catName;
                    }
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                }
            }
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    createTicketCat += this.cat[i].pid + '#' + this.cat[i].cid;
                    if (i !== this.cat.length - 1) {
                        createTicketCat += ',';
                    }
                } else {
                    isError = true;
                    break;
                }
            }
        } else {
            isError = true;
        }

        for (let i = 0; i < this.dynamicFields.length; i++) {
            if (this.dynamicFields[i].value !== '') {
                extraCount++;
                if (i === this.dynamicFields.length - 1) {
                    extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value;
                } else {
                    extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value + '#';
                }
            }
        }
        if (extraCount !== this.dynamicFields.length) {
            isAddFieldMissing = true;
        }
        extrafields = extrafields.substring(extrafields.length - 1, extrafields.length) === '#'
            ? extrafields.substring(0, extrafields.length - 1) : extrafields;

        // =================================create ticket data=============================================
        let create_ticket_data;
        const sourceType = this.messageService.getSourceType();
        if (sourceType !== null) {
            // console.log('if source type===' + sourceType);
            this.sourceType = sourceType;
        } else {
            // console.log('else source type===' + sourceType);
            this.sourceType = 'CIT Portal';
        }
        if (isError) {
            this.isError = true;
            this.errorMessage = this.messageService.CATEGORY_ERROR;
        } else if (this.ticketTypeSeq === 5 && (this.plannedStartDt === '' || this.plannedEndDt === '' || this.scheduleDuration === '' ||
            this.scheduleStartDate === '')) {
            this.notifier.notify('error', 'All Field Mandatory');
        } else if (this.ticketTypeSeq === 5 && (this.scheduleDuration <= 0 && this.plannedStartDt !== ''
            && this.plannedEndDt !== '' && this.scheduleStartDate !== '')) {
            this.notifier.notify('error', 'Scheduled duration must be greater than zero.');
        } else if ((this.ticketTypeSeq === 5 || this.ticketTypeSeq === 6) && (this.impact === 0 || this.urgency === 0 ||
            this.selectedPriority === 0)) {
            this.notifier.notify('error', 'All Field Mandatory');
        } else {
            if (this.priorityType === 1) {
                create_ticket_data = {
                    'ticket_type_seq': this.ticketTypeSeq,
                    'clientId': this.clientId,
                    'user_id': this.messageService.getUserId(),
                    'ticketTypeId': this.ticketTypeId,
                    // 'requesterInfo': this.name,
                    'tName': this.ticketTitle,
                    'longDesc': this.ticketDesc,
                    'attachmentPath': [],
                    'busi_priority_id': this.selectedPriority,
                    'tstatus': 1,
                    // 'requestedDate': this.rDate,
                    // 'dueDate': this.dDate,
                    'busi_impact_id': this.impact,
                    'busi_urgency_id': this.urgency,
                    'createdBy': this.messageService.getUserId(),
                    'categoryDtlsLt': createTicketCat,
                    'priorityType': this.priorityType,
                    'sourceType': this.sourceType,
                    'original_createdbyid': this.messageService.getUserId(),
                    'userGroupId': this.userGroupSelected,
                    'fieldValueDtls': extrafields,
                    'requesterInfo': this.name,
                    'ps-no': this.userName
                };
                if (this.ticketTypeSeq === 5) {
                    create_ticket_data['planned_start_dt'] = this.timeFormat1(this.plannedStartDt);
                    create_ticket_data['planned_end_dt'] = this.timeFormat1(this.plannedEndDt);
                    create_ticket_data['schedule_start_date'] = this.timeFormat1(this.scheduleStartDate);
                    create_ticket_data['schedule_duration'] = this.scheduleDuration;
                }
            } else if (this.priorityType === 2) {
                create_ticket_data = {
                    'ticket_type_seq': this.ticketTypeSeq,
                    'clientId': this.clientId,
                    'user_id': this.messageService.getUserId(),
                    'ticketTypeId': this.ticketTypeId,
                    // 'requesterInfo': this.name,
                    'tName': this.ticketTitle,
                    'longDesc': this.ticketDesc,
                    'attachmentPath': [],
                    'busi_priority_id': this.priorityId,
                    'tstatus': 1,
                    // 'requestedDate': this.rDate,
                    // 'dueDate': this.dDate,
                    'createdBy': this.messageService.getUserId(),
                    'categoryDtlsLt': createTicketCat,
                    'priorityType': this.priorityType,
                    'sourceType': this.sourceType,
                    'original_createdbyid': this.messageService.getUserId(),
                    'userGroupId': this.userGroupSelected,
                    'fieldValueDtls': extrafields,
                    'requesterInfo': this.name,
                    'ps-no': this.userName
                };
            }
            // ======================================================================================================

            const data = {
                client_id: this.clientId,
                ticketType: this.ticketSelected,
                category: cats,
                ticketTitle: this.ticketTitle,
                ticketDescription: this.ticketDesc,
                activityValue: activity,
                activityTypeId: 1,
                activityType: 'Adhoc',
                create_ticket_data: JSON.stringify(create_ticket_data),
                createdBy: this.messageService.getUserId(),
                groupId: this.userGroupSelected
            };
            // console.log('data before====' + JSON.stringify(data));
            const activityDate = new Date(this.activityValue);
            const currentDate = new Date();
            if (activityDate.getTime() > currentDate.getTime()) {
                if (!this.messageService.isBlankField(data)) {
                    if (extrafields !== '') {
                        data['fieldValueDtls'] = extrafields;
                    }
                    // console.log('data====' + JSON.stringify(data));
                    this._rest.insertAutoTicket(data).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {
                            this.isError = false;
                            this.nextOffset = 0;
                            this.page_no = 0;
                            this.getTableData();
                            // this.isError = false;
                            // const id = this.respObject.details;
                            // this.messageService.setRow({
                            //     id: id,
                            //     ticketType: this.ticketType,
                            //     category: categoryName,
                            //     ticket_title: this.ticketTitle,
                            //     ticket_description: this.ticketDesc,
                            //     activity_type: 'Adhoc',
                            //     activity_value: this.getdate(activity)
                            // });
                            // this.totalData = this.totalData + 1;
                            // this.messageService.setTotalData(this.totalData);
                            // if (this.totalData <= this.pageSize * this.page_no) {
                            //     this.offset = id;
                            //     this.nextOffset = 0;
                            // } else {
                            //     this.nextOffset = this.offset;
                            // }
                            this.ticketSelected = 0;
                            this.ticketDesc = '';
                            this.ticketTitle = '';
                            this.hideAddmore = true;
                            this.activityValue = '';
                            this.dynamicFields = [];
                            this.cat = [];
                            this.ticketTypes = [];
                            this.impact = 0;
                            this.urgency = 0;
                            this.selectedPriority = 0;
                        } else {
                            this.isError = true;
                            this.errorMessage = this.respObject.errorMessage;
                        }
                    }, (err) => {
                        this.isError = true;
                        this.errorMessage = this.messageService.SERVER_ERROR;
                    });
                } else {
                    this.isError = true;
                    this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
                }
            } else {
                this.isError = true;
                this.errorMessage = this.messageService.SCHEDULE_TICKET_TIME_ERROR;
            }
        }
    }

    getTableData() {
        // console.log(this.messageService.view)
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getdate_old(value) {
        const result = value.split(',');
        const result1 = result[0];
        const result2 = result1.split('-');
        const date = result2[1] + '-' + result2[0] + '-' + result2[2] + ',' + result[1];
        const dateIST = new Date(date);
        dateIST.setHours(dateIST.getHours());
        dateIST.setMinutes(dateIST.getMinutes());
        // console.log("+++++"+dateIST);
        value = this.messageService.datePipeFunc(dateIST);
        // console.log("===="+value);
        return value;
    }

    getdate(value) {
        const result = value.split(',');
        const result1 = result[0];
        const result2 = result1.split('-');
        const date = result2[1] + '-' + result2[0] + '-' + result2[2] + ',' + result[1];

        const dateIST = new Date(date);

        dateIST.setHours(dateIST.getHours());
        dateIST.setMinutes(dateIST.getMinutes());

        value = this.messageService.datePipeFunc(dateIST);
        return value;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getScheduleTicket(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
                if (this.respObject.details.dataObj[i].activity_type === 'Adhoc') {
                    this.respObject.details.dataObj[i].activity_value = this.getdate(this.respObject.details.dataObj[i].activity_value);
                }
            }
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }

    blockSpecialChar(e) {
        const k = e.keyCode;
        return (k !== 35 && k !== 64);
    }


    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }
    c() {
        this.myModal.close();
    }
}
